export default __webpack_public_path__ + "static/media/bbk-pembelian.8d2735cc.png";